import markup from './service-card.component.html?raw';
// Vite's ?inline query compiles the SCSS and returns it as a plain string so it
// can be injected into the shadow root. This keeps all styles encapsulated inside
// the component rather than living in the document stylesheet.
import styles from './service-card.component.scss?inline';

// The template is created once at module load — not per instance — so cloning it
// inside each card is cheap. This is the standard pattern for Shadow DOM components.
const template = document.createElement('template');
template.innerHTML = `
  <style>${styles}</style>
  ${markup}
`;

class ServiceCardElement extends HTMLElement {
  private readonly root: ShadowRoot;

  public constructor() {
    super();

    // Initialize shadow DOM once so internal logic can use a non-null root.
    this.root = this.attachShadow({ mode: 'open' });
    this.root.appendChild(template.content.cloneNode(true));
  }

  /**
   *
   */
  static get observedAttributes(): string[] {
    return ['color', 'cta-text', 'cta-url'];
  }

  /**
   *
   */
  public connectedCallback(): void {
    this.applyColor(this.getAttribute('color'));
    this.applyCtaText(this.getAttribute('cta-text'));
    this.applyCtaUrl(this.getAttribute('cta-url'));
    this.dataset['enhanced'] = 'true';
  }

  /**
   *
   */
  public attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null): void {
    if (name === 'color') {
      this.applyColor(newValue);
    } else if (name === 'cta-text') {
      this.applyCtaText(newValue);
    } else if (name === 'cta-url') {
      this.applyCtaUrl(newValue);
    }
  }

  // Sets --service-card-color on the host element. CSS custom properties DO cross
  // the shadow boundary, so the SCSS inside the shadow root can read this value.
  private applyColor(value: string | null): void {
    if (value) {
      this.style.setProperty('--service-card-color', value);
    } else {
      this.style.removeProperty('--service-card-color');
    }
  }

  /**
   *
   */
  private applyCtaText(value: string | null): void {
    const ctaLink = this.root.querySelector('.service-card__cta .btn');
    if (ctaLink) {
      ctaLink.textContent = value || 'Learn More';
    }
  }

  /**
   *
   */
  private applyCtaUrl(value: string | null): void {
    const ctaLink = this.root.querySelector('.service-card__cta .btn');
    if (ctaLink) {
      ctaLink.setAttribute('href', value || '#');
    }
  }
}

if (!customElements.get('service-card')) {
  customElements.define('service-card', ServiceCardElement);
}
